import React from 'react';
import { 
  Clock, Edit2, Eye, Trash, Trash2, Repeat, Plus, X, CheckCircle, 
  PowerOff, XCircle, PawPrint, Star, Heart, ShoppingCart, Copy, 
  Search,
  Shield,
  Map,
  MapPin,
  RefreshCcw
} from 'lucide-react';

type IconProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
};

const createIcon =
  (Component: React.FC<React.SVGProps<SVGSVGElement>>) =>
  ({ size = 20, ...rest }: IconProps) =>
    <Component width={size} height={size} {...rest} />;

export const IconEdit = createIcon(Edit2);
export const IconEye = createIcon(Eye);
export const IconTrash = createIcon(Trash);
export const IconDelete = createIcon(Trash2);
export const IconClock = createIcon(Clock);
export const IconRefund = createIcon(Repeat);
export const IconPlus = createIcon(Plus);
export const IconCancel = createIcon(X);
export const IconActivate = createIcon(CheckCircle); 
export const IconDeactivate = createIcon(PowerOff);
export const IconReject = createIcon(XCircle); 
export const IconPaw = createIcon(PawPrint);
export const IconReview = createIcon(Star);
export const IconHeart = createIcon(Heart);
export const IconCart = createIcon(ShoppingCart);
export const IconCopy = createIcon(Copy);
export const IconSearch = createIcon(Search);
export const IconShield = createIcon(Shield); 
export const IconMapPin = createIcon(MapPin); 
export const IconRefresh = createIcon(RefreshCcw);
